import { render, staticRenderFns } from "./TextItemSelect.vue?vue&type=template&id=f740fccc&"
import script from "./TextItemSelect.vue?vue&type=script&lang=ts&"
export * from "./TextItemSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports